import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchTicketById } from '../components/api';
import TicketDetailModal from '../components/TicketDetailModal';

const TicketPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const t = await fetchTicketById(id);
        setTicket(t);
      } catch (err) {
        console.error('Failed to fetch ticket', err);
        setError(err.message || 'Failed to load ticket');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) return <div className="flex items-center justify-center min-h-screen">Loading…</div>;
  if (error)   return <div className="flex items-center justify-center min-h-screen text-red-600">{error}</div>;
  if (!ticket) return <div className="flex items-center justify-center min-h-screen">Ticket not found</div>;

  return (
    <TicketDetailModal
      isOpen={true}
      ticket={ticket}
      onTicketUpdated={setTicket}
      onClose={() => {
        // Navigate back or to ticketing system
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate('/ticketing-system');
        }
      }}
    />
  );
};

export default TicketPage; 